import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-playboutton',
  templateUrl: './playboutton.component.html',
  styleUrls: ['./playboutton.component.scss']
})
export class PlaybouttonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
